export default __webpack_public_path__ + "static/media/5_core.a53ad852.svg";